import {
  Autocomplete,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import React from "react";
import { outletMetaData } from "../../features/editAndView/ViewAndEditType";
import { validDateEmail, validDateMobile } from "../../utils/utils";
import {
  beatType,
  channelType,
  outletCategoryType,
  outletForModelType,
  outletModelCustomerType,
  outletModelDataDetails,
  outletModelLocationType,
  outletModelSalesInfoType,
  outletType,
} from "./OutletModalTypes";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const OutletOverview = ({
  modelData,
  submit: { check, setCheck },
  additionalCachedData,
  defaultInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  disableEdit 
}: outletModelDataDetails) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  if (additionalCachedData) {
    if (additionalCachedData.length > 0) {
      additionalCachedData[0] = additionalCachedData[0].filter(
        ({ outletCategory }: outletCategoryType) => {
          return outletCategory !== null;
        }
      );
    }

    if (additionalCachedData.length > 1) {
      additionalCachedData[1] = additionalCachedData[1].filter(
        ({ outletType }: outletType) => {
          return outletType !== null;
        }
      );
    }

    if (additionalCachedData.length > 2) {
      additionalCachedData[2] = additionalCachedData[2].filter(
        ({ channel }: channelType) => {
          return channel !== null;
        }
      );
    }
  }

  return (
    <div className="model-child">
      <TextField
        label={translate(TranslationEnum.outlet_details,"outlet_code")}
        id="outlined-start-adornment"
        value={defaultInputs.outletCode}
        disabled={disableEdit} 
      />
      <TextField
        disabled={disableEdit}
        label={translate(TranslationEnum.outlet_details,"outlet_name")}
        id="outlined-start-adornment"
        value={defaultInputs.outletName}
        onChange={(e) => {
          setDefaultInputs((prev: outletMetaData) => ({
            ...prev,
            outletName: e.target.value,
          }));
          setEditRequestBody((prev: outletForModelType) => ({
            ...prev,
            outletName: e.target.value,
          }));
          setCheck(true);
        }}
      />
      <Autocomplete
       disabled={disableEdit} 
        disablePortal
        options={additionalCachedData[1].map(({ outletType }: outletType) => {
          return outletType;
        })}
        value={defaultInputs.outletType}
        onChange={(event, value: string | null) => {
          if (value) {
            setDefaultInputs((prev: outletMetaData) => ({
              ...prev,
              outletType: value,
            }));
            setEditRequestBody((prev: outletForModelType) => ({
              ...prev,
              outletType: value,
            }));
            setCheck(true);
          }
        }}
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.outlet_details,"Outlet Type")} />}
      />
      <Autocomplete
       disabled={disableEdit} 
        disablePortal
        options={additionalCachedData[0].map((data: outletCategoryType) => {
          return data.outletCategory;
        })}
        sx={{ width: "100%" }}
        renderInput={(params) => (
          <TextField {...params} label={translate(TranslationEnum.outlet_details,"Outlet Category")} />
        )}
        value={defaultInputs.outletCategory}
        onChange={(event, value: string | null) => {
          if (value) {
            setDefaultInputs((prev: outletMetaData) => ({
              ...prev,
              outletCategory: value,
            }));
            setEditRequestBody((prev: outletForModelType) => ({
              ...prev,
              outletCategory: value,
            }));
            setCheck(true);
          }
        }}
      />
      <Autocomplete
       disabled={disableEdit} 
        disablePortal
        options={additionalCachedData[2].map(({ channel }: channelType) => {
          return channel;
        })}
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.outlet_details,"Channel Type")} />}
        value={defaultInputs.channel}
        onChange={(event, value: string | null) => {
          if (value) {
            setDefaultInputs((prev: outletMetaData) => ({
              ...prev,
              channel: value,
            }));
            setEditRequestBody((prev: outletForModelType) => ({
              ...prev,
              channel: value,
            }));
            setCheck(true);
          }
        }}
      />
      <FormLabel sx={{ marginLeft: 1 }}>{translate(TranslationEnum.outlet_details,"Status")}</FormLabel>
      <RadioGroup
        sx={{ m: 1 }}
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={defaultInputs.activeStatus}
        onChange={(event, value) => {
          setDefaultInputs((prev: outletMetaData) => ({
            ...prev,
            activeStatus: value,
          }));
          setEditRequestBody((prev: outletForModelType) => ({
            ...prev,
            activeStatus: value,
          }));
          setCheck(true);
        }}
      >
        <FormControlLabel  disabled={disableEdit} value="active" control={<Radio />} label={translate(TranslationEnum.common_portal,"Active")} />
        <FormControlLabel
         disabled={disableEdit} 
          value="inactive"
          control={<Radio />}
          label= {translate(TranslationEnum.common_portal,"Non Active")}
        />
      </RadioGroup>
    </div>
  );
};

const SalesInformation = ({
  defaultInputs: { defaultInputs, setDefaultInputs },
  submit: { check, setCheck },
  requestBody: { editRequestBody, setEditRequestBody },
  additionalCachedData,
  disableEdit 
}: outletModelSalesInfoType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  return (
    <div className="model-child">
      <TextField
        label={translate(TranslationEnum.outlet_details,"SalesPersonID")}
        id="outlined-start-adornment"
        value={
          defaultInputs.extendedAttributes
            ? defaultInputs.extendedAttributes["parent-0-0-id"]
            : ""
        }
        disabled={true}
      />
      <TextField
        label={translate(TranslationEnum.outlet_details,"distributerID")}
        id="outlined-start-adornment"
        value={
          defaultInputs.extendedAttributes
            ? defaultInputs.extendedAttributes["parent-0-1-id"]
            : ""
        }
        disabled={true}
      />
    </div>
  );
};

const CustomerInformation = ({
  defaultInputs: { defaultInputs, setDefaultInputs },
  submit: { check, setCheck },
  requestBody: { editRequestBody, setEditRequestBody },
  validEmail: { validEmail, setValidEmail },
  validMobile: { validMobile, setValidMobile },
  disableEdit 
}: outletModelCustomerType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  const checkEmail = (value: string | "") => {
    setValidEmail(validDateEmail(value));
  };

  const checkMobile = (value: string | "") => {
    setValidMobile(validDateMobile(value));
  };

  return (
    <div className="model-child">
      <TextField
        disabled={disableEdit} 
        label={translate(TranslationEnum.outlet_details,"email")}
        id="outlined-start-adornment"
        defaultValue={defaultInputs.email}
        onChange={(e) => {
          setDefaultInputs((prev: outletMetaData) => ({
            ...prev,
            email: e.target.value,
          }));
          setEditRequestBody((prev: outletForModelType) => ({
            ...prev,
            email: e.target.value,
          }));
          checkEmail(e.target.value);
          setCheck(true);
        }}
        error={!validEmail}
        helperText={validEmail || "Please enter a valid email."}
      />
      <TextField
        disabled={disableEdit} 
        label={translate(TranslationEnum.outlet_details,"mobile")}
        id="outlined-start-adornment"
        defaultValue={defaultInputs.contactno}
        onChange={(e) => {
          setDefaultInputs((prev: outletMetaData) => ({
            ...prev,
            contactno: e.target.value,
          }));
          setEditRequestBody((prev: outletForModelType) => ({
            ...prev,
            contactno: e.target.value,
          }));
          checkMobile(e.target.value);
          setCheck(true);
        }}
        error={!validMobile}
        helperText={validMobile || "Please enter a valid Phone no"}
      />
    </div>
  );
};

const OutletLoaction = ({
  defaultInputs: { defaultInputs, setDefaultInputs },
  submit: { check, setCheck },
  requestBody: { editRequestBody, setEditRequestBody },
}: outletModelLocationType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  return (
    <div className="model-child">
      <TextField label="address" />
      <TextField
        label={translate(TranslationEnum.outlet_details,"country")}
        value={defaultInputs.country}
        disabled={true}
      />
      <div className="model-select">
        <Autocomplete
          disablePortal
          options={[]}
          sx={{ width: "49%" }}
          renderInput={(params) => <TextField {...params} label="Region" />}
        />
        <Autocomplete
          disablePortal
          options={[]}
          sx={{ width: "49%" }}
          renderInput={(params) => <TextField {...params} label="City" />}
        />
      </div>
    </div>
  );
};

const OtherOutletInfo = ({
  defaultInputs: { defaultInputs, setDefaultInputs },
  submit: { check, setCheck },
  requestBody: { editRequestBody, setEditRequestBody },
}: outletModelLocationType) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  return (
    <div className="model-child">
      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"AUART")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.AUART}
        />
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"KUNNR")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.KUNNR}
        />
      </div>
      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"PAYER")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.PAYER}
        />
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"VKBUR")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.VKBUR}
        />
      </div>

      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"SPART")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.SPART}
        />
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"VKORG")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.VKORG}
        />
      </div>
      <div className="model-select">
        <TextField
          sx={{ width: "49%" }}
          label={translate(TranslationEnum.outlet_details,"VTWEG")}
          id="outlined-start-adornment"
          value={defaultInputs.extendedAttributes?.VTWEG}
        />
      </div>
    </div>
  );
};

const PjpBeat = ({
  modelData,
  submit: { check, setCheck },
  additionalCachedData,
  defaultInputs: { defaultInputs, setDefaultInputs },
  requestBody: { editRequestBody, setEditRequestBody },
  disableEdit 
}: outletModelDataDetails) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT="OutletDetails";
  additionalCachedData[3] = additionalCachedData[3].filter(
    ({ beat }: beatType) => {
      return beat !== null;
    }
  );
  return (
    <div className="model-child">
      <TextField
        disabled={disableEdit} 
        label={translate(TranslationEnum.outlet_details,"frequency")}
        id="outlined-start-adornment"
        value={defaultInputs.frequency}
        onChange={(e) => {
          setDefaultInputs((prev: outletMetaData) => ({
            ...prev,
            frequency: e.target.value,
          }));
          setEditRequestBody((prev: outletForModelType) => ({
            ...prev,
            frequency: e.target.value,
          }));
          setCheck(true);
        }}
      />
      <Autocomplete
        disabled={disableEdit} 
        disablePortal
        options={additionalCachedData[3].map(({ beat }: beatType) => {
          return beat;
        })}
        sx={{ width: "100%" }}
        renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.outlet_details,"Beat")} />}
        value={defaultInputs.beat}
        onChange={(event, value: string | null) => {
          if (value) {
            setDefaultInputs((prev: outletMetaData) => ({
              ...prev,
              beat: value,
            }));
            setEditRequestBody((prev: outletForModelType) => ({
              ...prev,
              beat: value,
            }));
            setCheck(true);
          }
        }}
      />
    </div>
  );
};

export {
  OutletOverview,
  SalesInformation,
  CustomerInformation,
  OutletLoaction,
  OtherOutletInfo,
  PjpBeat,
};
